import classNames from 'classnames';
import {FC, useCallback, useState} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';

import styles from './PickupPoint.module.css';

type Props = {
    title: string;
    metroList?: string[];
    mapUrl?: string;
    selected?: boolean;
    onSelect: () => void;
};
export const PickupPoint: FC<Props> = ({
    title,
    metroList,
    selected,
    mapUrl,
    onSelect,
}) => {
    const [collapsed, setCollapsed] = useState(false);

    const handleCollapsed = useCallback(() => {
        setCollapsed(!collapsed);
    }, [collapsed]);

    return (
        <div
            className={classNames(styles.block, {
                [styles.active]: selected,
                [styles.collapsed]: collapsed,
            })}
        >
            <div
                className={classNames(styles.top, {
                    [styles.noBorder]: !mapUrl,
                })}
                onClick={onSelect}
            >
                {selected && (
                    <div className={styles.successIcon}>
                        <Icon name="success" />
                    </div>
                )}
                {!selected && (
                    <Icon name="location" className={styles.locationIcon} />
                )}
                <Text.Bold16>{title}</Text.Bold16>
                {metroList && (
                    <div className={styles.metroList}>
                        {metroList.map((metro) => (
                            <div key={metro} className={styles.metro}>
                                <Icon name="metro" />
                                <Text.Semibold14>{metro}</Text.Semibold14>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {mapUrl && (
                <>
                    <div className={styles.mapAction} onClick={handleCollapsed}>
                        <Text.Semibold14>На карте</Text.Semibold14>
                        <Icon name="arrow" className={styles.arrowIcon} />
                    </div>

                    <div className={styles.mapSection}>
                        <div className={styles.map}>
                            {/* конструктор - https://yandex.ru/map-constructor/?from=usermap&ll=37.611093,55.764845&z=17 */}
                            {collapsed && (
                                <iframe
                                    src={mapUrl}
                                    width="100%"
                                    frameBorder={0}
                                    height="400"
                                    title="map"
                                ></iframe>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
